import * as core from '../../../../../../../core'
import * as assetOwnership from '../asset-ownership'

export const RESOURCE = {
  payload: {
    description: 'Asset is being leased to the institution',
    enumId: core.dms.models.Enum.Id.from({
      partialId: assetOwnership.RESOURCE.payload.partialId,
    }),
    id: 'LEASED',
    name: 'Leased',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
